import Mailchimp from '../integrations/mailchimp';
import GetResponse from '../integrations/getresponse';


export default class FormsModule extends elementorModules.editor.utils.Module {
	onElementorInit() {

		this.mailchimp = new Mailchimp('ehp-form');
		this.getresponse = new GetResponse('ehp-form');

	}
}
